import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Deals from "./pages/Deals";
import DealDetail from "./pages/DealDetail";
import Contact from "./pages/Contact";
import Complaints from "./pages/Complaints";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Fairness from "./pages/Fairness";
import Compliance from "./pages/Compliance";

export default function App() {
    const [route, setRoute] = useState(window.location.hash || "#/");

    useEffect(() => {
        const onHashChange = () => setRoute(window.location.hash || "#/");
        window.addEventListener("hashchange", onHashChange);
        return () => window.removeEventListener("hashchange", onHashChange);
    }, []);

    if (route.startsWith("#/deal/")) {
        const date = decodeURIComponent(route.replace("#/deal/", ""));
        return (
            <div className="flex flex-col min-h-screen">
                <Header />
                <DealDetail date={date} />
                <Footer />
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <div className="flex-1">
                {route === "#/" && <Home />}
                {route === "#/about" && <About />}
                {route === "#/deals" && <Deals />}
                {route === "#/contact" && <Contact />}
                {route === "#/complaints" && <Complaints />}
                {route === "#/privacy" && <Privacy />}
                {route === "#/terms" && <Terms />}
                {route === "#/treating-customers-fairly" && <Fairness />}
                {route === "#/customer-duty-compliance" && <Compliance />}
            </div>
            <Footer />
        </div>
    );
}
